import IPayload from "@/interfaces/IPayload";
import api from "./api";
import { resources } from "./resources";
import { ToQueryString } from "@/utils/utils";

class RebateUsinaInstalacao {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.rebateUsinaInstalacao}${ToQueryString(filters)}`);
    }
}

export default new RebateUsinaInstalacao();
